export default __webpack_public_path__ + "static/media/chicken.f2ce6dda.jpeg";